import { Steps, theme, Modal, Spin } from "antd";

const App = ({
  isStatusModalOpen,
  setIsStatusModalOpen,
  showStatusModal,
  uploadStatus,
}) => {
  const steps = [
    {
      title: "Gallery Images",
      content: "Uploading gallery images, please wait...",
    },
    {
      title: "Floor Plan",
      content: "Uploading floor plan images, please wait...",
    },
    {
      title: "Final",
      content: "Finalizing upload, saving your data...",
    },
  ];

  const { token } = theme.useToken();
  const items = steps.map((item) => ({ key: item.title, title: item.title }));
  const contentStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "160px",
    textAlign: "center",
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
  };

  const activeStatusHandler = () => {
    if (uploadStatus === "Gallery") {
      return 0;
    } else if (uploadStatus === "Floor") {
      return 1;
    } else return 2;
  };

  return (
    <>
      <Modal
        title="Processing"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isStatusModalOpen}
        footer={false}
        width={1000}
      >
        <div style={{ marginTop: "20px" }}>
          <Steps current={activeStatusHandler()} items={items} />
          <div style={contentStyle}>
            <div style={{ marginBottom: "20px" }}>
              <Spin />
            </div>
            {steps[activeStatusHandler()]?.content}
          </div>
          {/* <div style={{ marginTop: 24 }}>
            {activeStatusHandler() < steps.length - 1 && (
              <Button type="primary" onClick={() => next()}>
                Next
              </Button>
            )}
            {activeStatusHandler() === steps.length - 1 && (
              <Button
                type="primary"
                onClick={() => message.success("Processing complete!")}
              >
                Done
              </Button>
            )}
            {activeStatusHandler() > 0 && (
              <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
                Previous
              </Button>
            )}
          </div> */}
        </div>
      </Modal>
    </>
  );
};

export default App;
